import {useState} from 'react';

export default class AuthModel {

  public visible: any;
  public setVisible: any;
  public password: any;
  public setPassword: any;
  public text: any;
  public setText: any;

  constructor() {
    [this.visible, this.setVisible] = useState(false);
    [this.password, this.setPassword] = useState('');
    [this.text, this.setText] = useState('Informe sua senha para prosseguir.');
  }

  limpar() {
    this.setVisible(false);
    this.setPassword('');
  }
}
